import { setElementOnClick } from '../../../../../../shared/scripts/ui_utils/DomUtils.ts';
import { sendStoreTabsClickedAnalytic } from '../../../../../../shared/scripts/analytics/sendStoreTabsClickedAnalytic.ts';
export var StoreMenuItem = /*#__PURE__*/ function(StoreMenuItem) {
    StoreMenuItem["Membership"] = "membership";
    StoreMenuItem["Rewards"] = "rewards";
    StoreMenuItem["Expansions"] = "expansions";
    StoreMenuItem["Maps"] = "maps";
    StoreMenuItem["Colors"] = "colors";
    StoreMenuItem["Avatars"] = "avatars";
    StoreMenuItem["Coins"] = "coins";
    return StoreMenuItem;
}({});
export const STORE_SIDEBAR_BUTTON_IDS = {
    membership: 'm-store-button-membership',
    expansions: 'm-store-button-expansions',
    maps: 'm-store-button-maps',
    colors: 'm-store-button-colors',
    avatars: 'm-store-button-avatars',
    coins: 'm-store-button-coins',
    rewards: 'm-store-button-rewards'
};
export const STORE_SIDEBAR_DIV_IDS = {
    membership: 'm-store-membership',
    expansions: 'm-store-expansion',
    maps: 'm-store-maps',
    colors: 'm-store-colors',
    avatars: 'm-store-avatars',
    coins: 'm-store-coins',
    rewards: 'm-store-referral'
};
export class UIMStoreSidebarController {
    setButtonActions() {
        setElementOnClick(this.membershipButton, this.getClickAction(this.membershipDiv, this.membershipButton, "membership"));
        setElementOnClick(this.expansionsButton, this.getClickAction(this.expansionsDiv, this.expansionsButton, "expansions"));
        setElementOnClick(this.avatarsButton, this.getClickAction(this.avatarsDiv, this.avatarsButton, "avatars"));
        setElementOnClick(this.colorsButton, this.getClickAction(this.colorsDiv, this.colorsButton, "colors"));
        setElementOnClick(this.coinsButton, this.getClickAction(this.coinsDiv, this.coinsButton, "coins"));
        setElementOnClick(this.mapsButton, this.getClickAction(this.mapsDiv, this.mapsButton, "maps"));
        setElementOnClick(this.rewardsButton, this.getClickAction(this.rewardsDiv, this.rewardsButton, "rewards"));
    }
    getClickAction(divElement, currentButton, tabName) {
        return ()=>{
            this.allDivs.forEach((container)=>{
                container.style.display = 'none';
            });
            divElement.style.display = '';
            this.allButtons.forEach((button)=>{
                button.classList.remove('active');
            });
            currentButton.classList.add('active');
            if (tabName != undefined) sendStoreTabsClickedAnalytic(tabName);
        };
    }
    openDefaultStorePage(newHash) {
        const hash = newHash !== null && newHash !== void 0 ? newHash : window.location.hash;
        switch(hash){
            case '#membership':
                this.getClickAction(this.membershipDiv, this.membershipButton)();
                break;
            case '#expansions':
                this.getClickAction(this.expansionsDiv, this.expansionsButton)();
                break;
            case '#colors':
                this.getClickAction(this.colorsDiv, this.colorsButton)();
                break;
            case '#avatars':
                this.getClickAction(this.avatarsDiv, this.avatarsButton)();
                break;
            case '#maps':
                this.getClickAction(this.mapsDiv, this.mapsButton)();
                break;
            case '#coins':
                this.getClickAction(this.coinsDiv, this.coinsButton)();
                break;
            case '#rewards':
                this.getClickAction(this.rewardsDiv, this.rewardsButton)();
                break;
            default:
                this.openMembership();
                break;
        }
    }
    openMembership() {
        this.allDivs.forEach((container)=>container.style.display = 'none');
        this.getClickAction(this.membershipDiv, this.membershipButton)();
    }
    openCoins() {
        this.allDivs.forEach((container)=>container.style.display = 'none');
        this.getClickAction(this.coinsDiv, this.coinsButton)();
    }
    openRewards() {
        this.allDivs.forEach((container)=>container.style.display = 'none');
        this.getClickAction(this.rewardsDiv, this.rewardsButton)();
    }
    constructor(){
        this.allDivs = [];
        this.allButtons = [];
        this.membershipButton = document.getElementById(STORE_SIDEBAR_BUTTON_IDS["membership"]);
        this.expansionsButton = document.getElementById(STORE_SIDEBAR_BUTTON_IDS["expansions"]);
        this.avatarsButton = document.getElementById(STORE_SIDEBAR_BUTTON_IDS["avatars"]);
        this.colorsButton = document.getElementById(STORE_SIDEBAR_BUTTON_IDS["colors"]);
        this.coinsButton = document.getElementById(STORE_SIDEBAR_BUTTON_IDS["coins"]);
        this.mapsButton = document.getElementById(STORE_SIDEBAR_BUTTON_IDS["maps"]);
        this.rewardsButton = document.getElementById(STORE_SIDEBAR_BUTTON_IDS["rewards"]);
        this.membershipDiv = document.getElementsByClassName(STORE_SIDEBAR_DIV_IDS["membership"])[0];
        this.expansionsDiv = document.getElementsByClassName(STORE_SIDEBAR_DIV_IDS["expansions"])[0];
        this.avatarsDiv = document.getElementsByClassName(STORE_SIDEBAR_DIV_IDS["avatars"])[0];
        this.colorsDiv = document.getElementsByClassName(STORE_SIDEBAR_DIV_IDS["colors"])[0];
        this.coinsDiv = document.getElementsByClassName(STORE_SIDEBAR_DIV_IDS["coins"])[0];
        this.mapsDiv = document.getElementsByClassName(STORE_SIDEBAR_DIV_IDS["maps"])[0];
        this.rewardsDiv = document.getElementsByClassName(STORE_SIDEBAR_DIV_IDS["rewards"])[0];
        this.allDivs = [
            this.membershipDiv,
            this.expansionsDiv,
            this.avatarsDiv,
            this.colorsDiv,
            this.coinsDiv,
            this.mapsDiv,
            this.rewardsDiv
        ];
        this.allButtons = [
            this.membershipButton,
            this.expansionsButton,
            this.avatarsButton,
            this.colorsButton,
            this.coinsButton,
            this.mapsButton,
            this.rewardsButton
        ];
        this.setButtonActions();
        this.openDefaultStorePage();
    }
}
